import React from "react";
import { useLocation, Link } from "react-router-dom";
import { LogIn, ArrowLeft } from "lucide-react";
import Logo from "../components/Logo";
import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export default function Login() {
  const location = useLocation();
  const { user, loading } = useAuth();

  if (user && !loading) return <Navigate to="/admin" replace />;

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#1a1a1a] flex items-center justify-center px-5">
      <div className="w-full max-w-md bg-[#242424] border border-white/10 rounded-md p-10">
        <div className="flex justify-center mb-8">
          <Logo />
        </div>
        <h1 className="text-3xl font-bold text-white text-center mb-2" style={{ fontFamily: "'Familjen Grotesk', serif" }}>
          Admin <span className="text-[#c5a76f]">Login</span>
        </h1>
        <p className="text-white/60 text-center text-sm mb-8">
          Log in om uw voorraad en aanvragen te beheren.
        </p>
        {location.state?.error && (
          <div className="mb-5 px-4 py-3 bg-red-900/20 border border-red-500/30 text-red-300 text-sm rounded">
            {location.state.error}
          </div>
        )}
        <button
          onClick={handleLogin}
          className="w-full flex items-center justify-center gap-3 px-6 py-3.5 bg-[#c5a76f] text-black hover:bg-[#d8bd86] transition-colors text-sm font-semibold tracking-widest uppercase rounded"
        >
          <LogIn className="w-4 h-4" /> Aanmelden met Google
        </button>
        <Link to="/" className="mt-6 flex items-center justify-center gap-2 text-white/50 hover:text-[#c5a76f] text-sm transition-colors">
          <ArrowLeft className="w-4 h-4" /> Terug naar website
        </Link>
      </div>
    </div>
  );
}
